import React from "react";
import { useIntl } from "react-intl";
import {
  IonCard,
  IonCardTitle,
  IonCardContent,
  IonCardHeader,
} from "@ionic/react";
import TextAreaItem from "../../../components/formItems/TextAreaItem";
import SelectItem from "../../../components/formItems/SelectItem";

const Satisfaction = (props) => {
  const { control, approved, loading, enabled } = props;
  const intl = useIntl();
  return (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          {intl.formatMessage({
            id: "app.mobile.satisfaction",
          })}
        </IonCardTitle>
      </IonCardHeader>

      <IonCardContent>
        <SelectItem
          name="report__satisfaction_feedback"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.report.satisfaction_feedback",
          })}
          params={{
            name: "meta/system_tables/house_visits/satisfaction_feedback",
          }}
          disabled={approved || !enabled}
          loading={loading}
        />

        <SelectItem
          name="report__plan_hours_feedback"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.report.plan_hours_feedback",
          })}
          params={{
            name: "meta/system_tables/house_visits/plan_hours_feedback",
          }}
          disabled={approved || !enabled}
          loading={loading}
        />

        <SelectItem
          name="report__complains_feedback"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.report.complains_feedback",
          })}
          params={{
            name: "meta/system_tables/house_visits/complains_feedback",
          }}
          disabled={approved || !enabled}
          loading={loading}
        />

        <TextAreaItem
          name="report__requests_feedback"
          control={control}
          label={intl.formatMessage({
            id: "app.mobile.forms.house_visits.report.requests_feedback",
          })}
          disabled={approved || !enabled}
          loading={loading}
          autoGrow={true}
        />
      </IonCardContent>
    </IonCard>
  );
};

export default Satisfaction;
